import {
  ComponentRef,
  Directive,
  inject,
  Input,
  ViewContainerRef,
} from '@angular/core';
import { dynComponents,dynamicControlType } from '../interface/dynamic-component';
import { FormUtilitiesService } from '../services/formutillity.service';
import { DataSharingService } from '../services/data-sharing.service';

@Directive({
  standalone: true,
  selector: '[renderFormControl]',
})
export class RenderFormControlDirective {
  @Input() formField!: any;
  @Input() formName!: any;
  @Input() formGroup: any;
  @Input() requiredStarColor: any; // default value
  protected formUtilities = inject(FormUtilitiesService);

  constructor(private readonly viewContainerRef: ViewContainerRef,private readonly dataSharing:DataSharingService) {}
  private componentRef!: ComponentRef<any>;

  async ngAfterViewInit() {
    this.viewContainerRef.clear();

    const controlType: dynamicControlType = this.formField?.control_type;

    if (controlType) {
      const component = dynComponents[controlType];

      this.componentRef = this.viewContainerRef.createComponent(component);
      this.componentRef.instance.type = this.formField.input_type;
      if(this.formField.input_type == 'password'){
        this.componentRef.instance.isPassword = "true"
      }
      this.componentRef.instance.label = this.formField.field_label;
      this.componentRef.instance.controlName = this.formField.control_name;
      this.componentRef.instance.rows = this.formField.rows;
      this.componentRef.instance.size = this.formField?.configuration[0].field_size;

      this.componentRef.instance.cols = this.formField.cols;
      this.componentRef.instance.id = this.formField.field_id;

      this.componentRef.instance.isDisabled = this.formField.is_disabled;
      this.componentRef.instance.data = this.formField.options;
      this.componentRef.instance.formGroup = this.formGroup;
      this.componentRef.instance.placeholder = this.formField.placeholder;
      this.componentRef.instance.requiredStarColor = this.requiredStarColor
      if ( this.formField.validators?.length) {
        let selectedvalidator = this.formField.validators.filter(
          (validator: any) => {
            return validator.type === 'required';
          }
        );
        this.componentRef.instance.isRequired = !!selectedvalidator.length;
      }
      if ( this.formField.validators?.length) {
        let selectedvalidator = this.formField.validators.filter(
          (validator: any) => {
            return validator.type === 'maxlength';
          }
        );
        this.componentRef.instance.maxlength = selectedvalidator.length ? selectedvalidator[0].value : null;
      }
      if ( this.formField.validators?.length) {
        let temp = this.formField.validators.filter(
          (validator: any) => {
            return validator.type === 'alphaNumeric';
          }
        );
        this.componentRef.instance.isAlpha = !!temp.length;
      }
      if ( this.formField.validators?.length) {
        let temp = this.formField.validators.filter(
          (validator: any) => {
            return validator.type === 'isNumeric';
          }
        );
        this.componentRef.instance.isNumeric = temp.length
      }
      if (this.formField.validators?.length) {
          let validatorList = this.formField.validators.filter(
            (validator: any) => {
              return validator.type === 'phoneNumber';
            }
          );
        this.componentRef.instance.isPhoneNumber = validatorList.length
      }
      if (this.formField.validators?.length) {
        let tempList = this.formField.validators.filter(
          (validator: any) => {
            return validator.type === 'zipCode';
          }
        );
      this.componentRef.instance.isZipCode = tempList.length
    }
    if ( this.formField.validators?.length) {
      let tempList = this.formField.validators.filter(
        (validator: any) => {
          return validator.type === 'city';
        }
      );
    this.componentRef.instance.isCity = tempList.length
  
  }
    if (this.formField?.control_type === 'button') {
           this.componentRef.instance.className =
               'btn-primary-outline form-btn';
     }
      if (
        this.formField.input_type == 'checkbox' &&
        this.formField.options.length
      ) {
        this.componentRef.instance.controls =
          this.formGroup.controls[this.formField.control_name]['controls'];
      }
      if (this.componentRef.instance.controlName === 'DateOfBirth') {
        this.componentRef.instance.maxDate = new Date();
      }
      if (this.componentRef.instance.controlName === 'DateOfBirth') {
        this.componentRef.instance.dateChange.subscribe((data: any) => {
          this.dataSharing.setFormData(data); 
        });
      }
      if (this.componentRef.instance.controlName === 'sameAsHome') {
        this.componentRef.instance.change.subscribe((data: any) => {
          console.log(`Data received from dynamic component: ${data}`);
        });
      }
      this.componentRef.changeDetectorRef.detectChanges();
    }
  }
}
